import { DefaultPageHeader } from 'layouts';
import { usePermissions } from 'permissions';
import { AdminConsoleButton } from 'features/admin-dashboard';
import { JoinedProgramsList } from './joined-programs-list';

type P = {
  getPathToProgramDetail: (id: string) => string;
};

const JoinedPrograms = ({ getPathToProgramDetail }: P) => {
  const { canViewAdminDashboardPrograms } = usePermissions();

  return (
    <>
      <DefaultPageHeader
        extra={canViewAdminDashboardPrograms({}) ? <AdminConsoleButton entityType="program" /> : null}
        title="Programs"
      />

      <JoinedProgramsList getPathToProgramDetail={getPathToProgramDetail} />
    </>
  );
};

export default JoinedPrograms;
